export default {
	data () {
		return {
			auth: this.$page?.props?.auth || {},
			impersonating: this.$page.props.impersonating === true
		}
	},
	watch: {
		'$page.props.auth' () {
			this.auth = this.$page.props.auth
		},
		'$page.props.impersonating' () {
			this.impersonating = this.$page.props.impersonating === true
		}
	},
	computed: {
		authenticated () {
			return Object.keys(this.auth).length > 0
		},
		isAdmin () {
			return this.authenticated && (this.auth.type === 'admin' || this.auth.type === 'developer')
		},
		isManager () {
			return this.authenticated && this.auth.type === 'manager'
		},
		isEmployee () {
			return this.authenticated && this.auth.type === 'employee'
		},
		isDeveloper () {
			return this.authenticated && this.auth.type === 'developer'
		},
		isStaff () {
			if(! this.authenticated) {
				return false
			}

			return ['admin', 'manager', 'employee', 'developer']
				.includes(this.auth.type)
		},
		isClient () {
			if(! this.authenticated) {
				return false
			}

			return ['unknown', 'broker', 'client']
				.includes(this.auth.type)
		},
		isGuest () {
			return ! this.authenticated
		}
	}
}
